<template>
  <div class="upload-unit"
       :class="{'is-error':errors.has('file')}">
    <gt-upload class="upload-demo"
               :before-upload="beforeFileUpload"
               :before-remove="beforeFileRemove"
               :on-remove="fileRemove"
               :on-exceed="fileExceed"
               :show-file-list="false"
               :limit="limitNumber"
               ref="upload"
               :http-request="_Upload"
               :file-list="fileList"
               action="''">
      <gt-button v-if="fileList.length < limitNumber && !loading"
                 class="upload-btn"
                 plain><i class="iconfont iconshangchuan1"></i>上传文件</gt-button>
    </gt-upload>
    <gt-button class="upload-btn"
               plain
               v-if="loading"
               :loading="loading">上传中</gt-button>
    <gt-button v-if="fileList.length >= limitNumber  && !loading"
               class="upload-btn success-btn"
               plain><i class="iconfont iconrenzhengchenggong"></i>上传成功</gt-button>
    <ul class="success-tip"
        v-if="fileList.length">
      <li v-for="(v, $index) in fileList"
          :key="$index">
        <span class="file-name"
              :title="v.name">{{v.name}}</span><i class="iconfont iconguanbi"
           @click="remove($index)"></i>
      </li>
    </ul>
    <span class="tip"
          v-if="tip">{{tip}}</span>
    <input class="gt-facker-input"
           v-model="file"
           v-validate="'required'"
           name="file" />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UploadUnit',
  model: {
    prop: 'sourceData',
    event: 'input'
  },
  props: {
    category: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ''
    },
    limitNumber: {
      type: Number,
      default: 1
    },
    limitSize: { // 文件大小
      type: Number,
      default: 20
    },
    validateFul: { // 是否校验
      type: Boolean,
      default: true
    },
    tip: { // 常规提示
      type: String,
      default: ''
    },
    limitType: { // 文件类型提示
      type: Array,
      default () {
        return []
      }
    },
    sourceData: {
      type: [Object, Array],
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      fileName: '',
      file: '',
      fileList: [],
      suffixRegList: []
    }
  },
  methods: {
    remove (index) {
      this.fileList.splice(index, 1)
      this.file = ''
      if (this.limitNumber > 1) {
        let records = this.fileList.map(el => { // filelist 会被上传组件污染，做个过滤
          return {
            id: el.id,
            name: el.name
          }
        })
        if (records.length) this.$emit('input', records)
        else this.$emit('input', [])
      } else {
        this.$emit('input', { id: '', name: '' })
      }
      this.$emit('uploadClear')
    },
    clearFiles () {
      this.fileList.splice(0, this.fileList.length)
    },
    getFileType (file) {
      const nameMap = {
        jpg: 1,
        jpeg: 1,
        png: 1,
        bmp: 1,
        rar: 2,
        zip: 2,
        pdf: 3
      }
      let names = file.name.split('.')
      return nameMap[names[names.length - 1]]
    },
    fileRemove (target) {
      if (target.status === 'ready') return false
      let index = this.files.indexOf(target.realUrl || target.url)
      if (index < 0) return false
      this.files.splice(index, 1)
      this.fileList.splice(index, 1)
    },
    fileExceed (files, fileList) {
      this.$message.error(`上传文件不能超过 ${this.limitNumber} 个!`)
    },
    beforeFileUpload (file) {
      if (this.loading) {
        this.$message.warning(`上传中，请稍等！`)
        return false
      }
      let isOk = false
      this.suffixRegList.forEach(reg => { // 只根据后缀名进行校验，不同系统文件内容和类型不太一样，其它页面亦是如此。
        if (reg.test(file.name.toLocaleLowerCase())) isOk = true
      })
      const isLimitSize = file.size / 1024 / 1024 < this.limitSize

      if (!isOk) {
        this.$message.error(`上传文件只能是 ${this.limitType.join(',')} 格式!`)
      }
      if (!isLimitSize) {
        this.$message.error(`上传文件大小不能超过 ${this.limitSize} MB!`)
      }
      return isOk && isLimitSize
    },
    async beforeFileRemove (item) {
      let result
      if (item.status === 'ready') return Promise.resolve()
      await this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功!')
        result = true
      }).catch(() => {
        this.$message.info('已取消删除!')
        result = false
      })
      if (!result) {
        return Promise.reject(new Error())
      } else {
        return Promise.resolve()
      }
    },
    updateInit () {
      if (!this.files.length) return false
      let zipReg = /.(zip|rar)$/
      this.files.forEach((url, $index) => {
        let file = {
          name: $index,
          realUrl: url,
          url: zipReg.test(url) ? this.zipSuccessIcon : this.imgUrlPrefix + url
        }
        this.fileList.push(file)
      })
    },
    validate () {
      return this.$validator.validateAll()
    },
    _Upload (item) {
      // console.log(item)
      this.loading = true
      let formData = new FormData()
      formData.append('file', item.file)
      formData.append('category', this.category)
      this.$http.post(this.url, formData).then(res => {
        let record = res.data.data
        this.fileName = record.name
        this.fileList.push(record)
        this.file = 'init' // 随便赋值，用于校验
        if (this.limitNumber > 1) {
          let records = this.fileList.map(el => { // filelist 会被上传组件污染，做个过滤
            return {
              id: el.id,
              name: el.name
            }
          })
          this.$emit('input', records)
        } else {
          this.$emit('uploadSuccess', record) // 往外传的一样，是为了个别字段能使用
          this.$emit('input', record) // 与业务接口
        }
        this.loading = false
        this.$validator.validateAll()
      }, errRes => {
        this.$refs.upload.clearFiles()
        this.loading = false
      })
    }
  },
  created () {
    if (this.limitNumber > 1) {
      this.fileList = this.sourceData.map(el => el)
      if (this.fileList.length) this.file = 'init'
    } else {
      this.fileName = this.sourceData.name
      if (this.fileName) {
        this.fileList.push(this.sourceData)
        this.file = 'init'
      }
    }

    this.limitType.forEach(el => {
      this.suffixRegList.push(new RegExp(`.${el}$`))
    })
  }
}
</script>

<style lang='less' scoped>
.upload-unit {
  display: table;
  position: relative;
  vertical-align: top;
  .upload-demo {
    display: table-cell;
  }
  .upload-btn {
    display: inline-block;
    margin-right: 20px;
    width: 106px;
    height: 30px;
    border-color: @base-viColor;
    // color: @base-viColor;
    color: #333333;
    // &:hover,
    // &:focus {
    //   color: #333333;
    // }
    .iconfont {
      margin-right: 6px;
      font-size: 14px;
      font-weight: normal;
      // color: @base-viColor;
    }
  }
  .success-btn {
    color: @base-viColor;
    .iconfont {
      color: @base-viColor;
    }
  }
}
.is-error {
  .upload-btn {
    border-color: @form-danger !important;
    .iconfont {
      color: @form-danger;
    }
  }
}
.tip {
  display: table-cell;
  margin-left: 14px;
  font-size: 14px;
  color: #999999;
  white-space: nowrap;
}
.success-tip {
  display: table-cell;
  padding: 0 30px 0 0;
  margin: 0 0 0 14px;
  font-size: 14px;
  li {
    position: relative;
  }
  .file-name {
    display: table-cell;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #4384bc;
    text-decoration: underline;
  }
  .iconfont {
    position: absolute;
    right: -14px;
    top: -8px;
    font-size: 10px;
    color: #cccccc;
    cursor: pointer;
  }
}
.gt-facker-input {
  position: absolute;
  z-index: -10;
  opacity: 0;
}
</style>
